import { Reducer } from 'redux';
import { IEnv } from '..';
import { EnvAction, EnvActionType } from '../actions';

export const EnvReducer: Reducer<IEnv> = (
  state: IEnv = { nonce: '', props: {}, wpAjaxAdminUrl: '' },
  action: EnvAction
) => {
  switch (action.type) {
    case EnvActionType.UPDATE_ENV:
      return { ...action.env };
  }
  return state;
};
